import { withOktaAuth } from '@okta/okta-react';
import {
  OktaAuth, AuthState as OktaAuthState, OktaAuthOptions, toRelativeUrl,
} from '@okta/okta-auth-js';
import MainService from './main-service';
import { ROUTE_OKTA_LOGIN_CALLBACK } from '../constants/system/routes';
import HTTP_PROTOCOL_HTTPS from '../constants/system/http-protocols';

export default class OktaService {
  private static OKTA_ROUTE_OAUTH_DEFAULT: string = '/oauth2/default';
  private static OKTA_MAIN_HOST: string = 'okta.com';

  private static client: OktaAuth | null = null;

  public static getClient(accountName: string | null, accountClientId: string | null): OktaAuth | null {
    if (!accountName || !accountClientId) {
      return null;
    }

    if (!this.client) {
      this.client = new OktaAuth(this.getConfig(accountName, accountClientId));
    }

    return this.client || null;
  }

  public static withOktaAuth(component: ReactComponent): ReactComponent {
    return withOktaAuth(component) as ReactComponent;
  }

  public static checkIsOktaAuthenticated(oktaAuthState: OktaAuthState): boolean {
    return (oktaAuthState && oktaAuthState.isAuthenticated) || false;
  }

  public static async oktaLogout(oktaAuth: OktaAuth): Promise<void> {
    if (oktaAuth) {
      await oktaAuth.revokeAccessToken();
    }
  }

  public static async restoreOriginalUri(originalUri: string, onRestoreOriginalUri: Function): Promise<void> {
    const baseHost: string | undefined = MainService.BASE_HOST;

    if (baseHost && onRestoreOriginalUri) {
      onRestoreOriginalUri(toRelativeUrl(originalUri || '/', baseHost));
    }
  }

  private static getConfig(accountName: string, accountClientId: string): OktaAuthOptions {
    const oktaHost: string = `${HTTP_PROTOCOL_HTTPS}${accountName}.${this.OKTA_MAIN_HOST}`;
    const isOktaDevMode: boolean = !!MainService.OKTA_DEV_MODE;
    const baseHost: string | undefined = MainService.BASE_HOST;

    return {
      issuer: `${oktaHost}${isOktaDevMode ? this.OKTA_ROUTE_OAUTH_DEFAULT : ''}`,
      clientId: accountClientId,
      redirectUri: baseHost ? `${baseHost}${ROUTE_OKTA_LOGIN_CALLBACK}` : undefined,
    };
  }
}
